import { Check, Globe } from "lucide-react";
import type { FunctionComponent } from "react";
import { Button, Dropdown, type MenuProps } from "~/components/ui";
import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES, useChangeLanguage } from "@noa/i18n";
import { localLanguageStorage } from "~/utils/language-storage";

export const AppLanguageSelector: FunctionComponent = () => {
  const { i18n } = useTranslation();
  const handleLanguageChange = useChangeLanguage(localLanguageStorage);

  const menuItems: MenuProps["items"] = SUPPORTED_LANGUAGES.map(({ code, selectionLabel }) => {
    const isSelected = i18n.language === code;

    return {
      key: code,
      disabled: isSelected,
      onClick: () => handleLanguageChange(code),
      label: (
        <div className="flex items-center gap-2">
          {selectionLabel} {isSelected && <Check size={10} />}
        </div>
      ),
    };
  });

  return (
    <Dropdown menu={{ items: menuItems }} placement="bottomRight">
      <Button className="border-2" variant="default" shape="circle" icon={<Globe size={16} />} />
    </Dropdown>
  );
};
